import { Box, Button, Drawer, IconButton, Typography, useMediaQuery } from "@mui/material"
import { DoubleArrow } from "@mui/icons-material"
import theme from "src/theme/light"

interface InformationDrawerOffGridProps{
  isOpen: boolean
  close: () => void
}

interface TitleProps {
  text: string
}

interface Item {
  title?: string;
  items: string[]
}

const WHATSAPP_PHONE = "(48) 2106-0006"
const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=55${WHATSAPP_PHONE.replace(/\D/g, '')}`

const items: {[index: string]: Item[]} = {
  'Tipo de baterias': [{
    items: [
      '- Bateria Chumbo: Opção mais acessível, indicada para projetos com menor investimento inicial. Exige manutenção periódica e possui menor vida útil (quantidade de ciclos).',
      '- Bateria Lítio: Investimento maior, maior durabilidade, eficiência, menor necessidade de manutenção e melhor aproveitamento da energia ao longo do tempo.'
    ],
  }],
  'Autonomia do banco de baterias (horas)': [
    {
      items: [
        'Tempo médio de fornecimento de energia apenas pelas baterias (sem geração solar).'
      ]
    }
  ],
  'Tensão de saída – Volts (V)': [{
    items: [
      'Tensão dos equipamentos ou da residência a serem alimentados pelo sistema.'
    ]
  }],
  'Tipo de estrutura': [{
    items: [
      'A recomendação das estruturas considerará a disposição dos módulos em uma (1) fileira, na posição retrato. Este campo exibe o tipo de estrutura da primeira fileira quando múltiplas fileiras são configuradas.'
    ]
  }],
  'Dúvidas': [{
    items: [
      `Em caso de dúvidas,  consulte a conta de luz do cliente ou nos ligue pelo telefone e whatsapp: <a target="_blank" href=${WHATSAPP_URL}>${WHATSAPP_PHONE}</a>`
    ]
  }]
}


const Title = ({ text }: TitleProps) => {
  return (
    <Box my={4} className="drawer-offgrid-title">
      <Typography variant="h5" color="primary"><strong>{text}</strong></Typography>
    </Box>
  )
}

export function InformationDrawerOffGrid({ isOpen, close }: InformationDrawerOffGridProps){
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Drawer anchor="right" open={isOpen} onClose={close} className="drawer-offgrid-info">
      <Box className="drawer-container">
        <Box className="drawer-content">
          { !isMobile && (
            <Box width="40px" height="40px" margin="18px 0 0 18px">
              <IconButton onClick={close} aria-label="Fechar drawer" size="large">
                <DoubleArrow />
              </IconButton>
            </Box>
          )}

          <Box width={isMobile ? "auto" : "400px"} px={isMobile ? 0 : 4} mb={4}>
            {Object.keys(items).map((title) => {
              const item = items[title]

              return (
                <>
                  <Title text={title} />
                  {item.map(register => {
                    return (
                      <Box mt={4} className="drawer-offgrid-text">
                        {register.title && <Typography variant='body1' color="textSecondary"><strong>{register.title}</strong></Typography>}
                        {register.items.map(item => {
                          return <div style={{ color: theme.palette.text.secondary, fontSize: 16  }} dangerouslySetInnerHTML={{__html: item}}></div>
                        })}
                      </Box>
                    )
                  })}
                </>
              )
            })}
          </Box>
        </Box>

        { isMobile && (
          <Box className="drawer-footer">
            <Button onClick={close} fullWidth variant="outlined" color="secondary" className="close-btn">
              Fechar
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}
